import { apiClient } from '@/lib/api/client'

type ApiResponse<T> = {
  success?: boolean
  message?: string
  data?: T
  meta?: { current_page?: number; last_page?: number; total?: number }
}

export type AppNotification = {
  id: number
  title: string
  message: string
  type: string
  is_read: boolean
  url?: string | null
  meta?: {
    child_ticket_id?: number
    parent_ticket_id?: number
    task_number?: string | null
    [key: string]: unknown
  } | null
  created_at?: string | null
}

function unwrapList(res: { data?: ApiResponse<AppNotification[]> | AppNotification[] }): AppNotification[] {
  const payload = res.data
  if (Array.isArray(payload)) return payload
  const nested = (payload as ApiResponse<AppNotification[]>)?.data
  return Array.isArray(nested) ? nested : []
}

const NOTIFICATIONS_BASE = '/support/notifications'

export const notificationService = {
  async listMine(params?: { per_page?: number; type?: string }): Promise<AppNotification[]> {
    const res = await apiClient.get<ApiResponse<AppNotification[]>>(NOTIFICATIONS_BASE, {
      params: { per_page: params?.per_page ?? 20, type: params?.type },
    })
    return unwrapList(res).map((row) => ({
      ...row,
      is_read: Boolean(row.is_read),
      meta:
        typeof row.meta === 'string'
          ? (JSON.parse(row.meta as unknown as string) as AppNotification['meta'])
          : row.meta ?? null,
    }))
  },

  async unreadCount(typePrefix?: string): Promise<number> {
    const res = await apiClient.get<{ unread_count?: number }>(`${NOTIFICATIONS_BASE}/unread/count`, {
      params: typePrefix ? { type: typePrefix } : undefined,
    })
    return Number(res.data?.unread_count ?? 0)
  },

  async markRead(id: number): Promise<void> {
    await apiClient.post(`${NOTIFICATIONS_BASE}/${id}/read`)
  },

  async markAllRead(): Promise<void> {
    await apiClient.post(`${NOTIFICATIONS_BASE}/mark-all-read`)
  },
}
